/**
 * External Dependencies
 * Comment out scripts that are not used to save on page load
 */
import { Button, Collapse, Modal, Tab } from 'bootstrap';
import { CountUp } from 'countup.js';
// import sheets_data from './sheets_data';
// import 'select2';
import AOS from 'aos';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/lazysizes';
// import '@lottiefiles/lottie-player';

/**
 * Internal Scripts
 * Comment out scripts that are not used to save on page load
 */
// import './disclaimer.js';
// import './people.js';
import './slider.js';
// Hide show back to top links.
const backToTop = (el) => {
  if (window.pageYOffset > 300) {
    $(el).fadeIn();
  } else {
    $(el).fadeOut();
  }

  document.querySelectorAll(el).forEach(function(element, index) {
    element.addEventListener('click', function() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, { once: true });
  });
};

const countStart = () => {
  const counters = document.querySelectorAll('.js-count-up');

  counters.forEach((item) => {
    const value = item.dataset.value;
    const decOptions = {
      decimalPlaces: 1,
    };

    if(value.indexOf('.') >= 0) {
      const counter = new CountUp(item, value, decOptions);
      counter.start();
    } else {
      const counter = new CountUp(item, value);
      counter.start();
    }
  });
};

// Add scroll class on scroll/load
const $window = $(window);
const $body = $('body');
const $header = $('.header');
let lastScrollTop = 0; // Variable to store the last scroll position

$window.on("scroll load", function () {
  const currentScrollTop = $window.scrollTop();

  // Remove "scrolled" class when at the very top of the page
  if (currentScrollTop === 0) {
    $body.removeClass("scrolled");
    $header.css('top', ''); // Reset the header position
    return;
  }

  // Add or remove "scrolled" class based on scroll position
  if (currentScrollTop > 100) {
    $body.addClass("scrolled");
  } else {
    $body.removeClass("scrolled");
  }

  // Header scroll show/hide based on scroll direction
  if (currentScrollTop > lastScrollTop) {
    $header.css('top', '-100%'); // Hide header on scroll down
  } else {
    $header.css('top', ''); // Show header on scroll up
  }

  lastScrollTop = currentScrollTop;
});

$(() => {

  AOS.init({
    once: true,
    offset: 500,
    disableMutationObserver: false,
  });

  AOS.refresh(true);

  // sheets_data.init();

  // Get CSS variables
  let root = getComputedStyle(document.documentElement);
  let colorPrimary = root.getPropertyValue('--primary');
  let colorSecondary = root.getPropertyValue('--secondary');
  let xsBreakpoint = root.getPropertyValue('--breakpoint-xs').replace('px','');
  let smBreakpoint = root.getPropertyValue('--breakpoint-sm').replace('px','');
  let mdBreakpoint = root.getPropertyValue('--breakpoint-md').replace('px','');
  let lgBreakpoint = root.getPropertyValue('--breakpoint-lg').replace('px','');
  let xlBreakpoint = root.getPropertyValue('--breakpoint-xl').replace('px','');

  const navCollapsible = document.getElementById('navbar');
  const $body = $('body');

  // Scroll to open accordion
  // see example https://stackoverflow.com/questions/35992900/bootstrap-accordion-scroll-to-top-of-active-open-accordion-on-click#answer-35992958
  $('.accordion-collapse').on('shown.bs.collapse', function (e) {
    let $panel = $(this).closest('.accordion-item');
    if($('#wpadminbar').length) {
      $('html,body').animate({
        scrollTop: ($panel.offset().top - ($('header.header').outerHeight() + $('#wpadminbar').outerHeight())),
      }, 500);
    } else {
      $('html,body').animate({
        scrollTop: $panel.offset().top - $('header.header').outerHeight(),
      }, 500);
    }
  });

  // Enable select2
  // $('select').select2({
  //   selectionCssClass: ':all:',
  //   theme: 'bootstrap-5',
  // });

  // Count up on scroll to
  if ($('.stats').length) {
    const countStart = (item) => {
      const value = item.dataset.value;
      const decOptions = {
        decimalPlaces: 1,
      };

      if(value.indexOf('.') >= 0) {
        const counter = new CountUp(item, value, decOptions);
        counter.start();
      } else {
        const counter = new CountUp(item, value);
        counter.start();
      }
    };

    // IntersectionObserver callback
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Retrieve the delay from the element's data attribute, or use a default
          const delay = entry.target.dataset.delay ? parseInt(entry.target.dataset.delay, 10) : 0; // Default delay is 0ms

          setTimeout(() => {
            // Execute the countStart for the individual stat element
            countStart(entry.target);

            // Optionally, stop observing the target if it's a one-time action
            observer.unobserve(entry.target);
          }, delay);
        }
      });
    };

    // Setting up the IntersectionObserver
    const observerOptions = {
      // Your options here (e.g., root, rootMargin, threshold)
    };
    const observer = new IntersectionObserver(callback, observerOptions);

    // Observing each stat element individually
    document.querySelectorAll('.js-count-up').forEach((target) => {
      observer.observe(target);
    });
  }

  // Smooth scroll to
  $('.nav-link').on('click', function () {
    if (!$(this).hasClass("dropdown-toggle")) {
      const $link = $('.nav-link');
      const sectionTo = $(this).attr('href').replace(new RegExp('/', ''),"");
      const header = $('.header').height();
      const navbar = $('#navbar');
      const $this = $(this);

      $link.removeClass('active');
      $this.addClass('active');

      $(navbar).collapse('hide');

      $('html,body').animate({
        scrollTop: $(sectionTo).offset().top - header,
      }, 500);
    }
  });

  // Popup modal
  $('a[href*="#bs-modal"]').each(function() {
    $(this).attr('data-bs-toggle', 'modal');
  });

  window.addEventListener('scroll', function() {
    backToTop('#back2top');
  });

  navCollapsible.addEventListener('shown.bs.collapse', event => {
    $body.addClass('nav-open');
  });

  navCollapsible.addEventListener('show.bs.collapse', event => {
    $('header #navbar').addClass('slide');
  });

  navCollapsible.addEventListener('hidden.bs.collapse', event => {
    if($body.hasClass('nav-open')) {
      $body.removeClass('nav-open');
    }
  });

  navCollapsible.addEventListener('hide.bs.collapse', event => {
    $('header #navbar').removeClass('slide');
  });
});

window.addEventListener('load', function () {
  backToTop('#back2top');
}, false);
